module.exports = __webpack_public_path__ + "img/prezzie.456dfcf2.svg";